module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/element-ui/~/core-js/library/modules/_library.js
// module id = 171
// module chunks = 0